<!-- 此component用來預設filter的勾選用 -->
<template id="CheckFilter">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container"> 
          <el-button class="apply-btn" type="primary" @click="applyFilter">套用</el-button>
          <el-button v-if="this.$store.state.checkedFilterLists.length === 0" class="cancel-btn" type="primary" @click="cancelFilter">取消</el-button>
          <el-button v-else class="cancel-middle-btn" type="primary" @click="cancelFilter">取消</el-button>
          <el-button v-if="this.$store.state.checkedFilterLists.length > 0" class="clear-btn" type="primary" @click="clearAllFilters">全部清除</el-button>
          <div class="modal-body"> 
            <el-form ref="form" :model="form">
              <el-form-item label="部門" class="check-group" style="width:200px"> 
                <br>    
                <el-cascader placeholder="選擇部門"
                  v-model="localCheckedDeps" :show-all-levels="false"
                  :options="this.$store.state.actualDepsOptions" @change="handleCheckedDepsChange">
                </el-cascader>
              </el-form-item>
               <el-form-item label="更新時間" class="check-group"> 
                <br>    
                <el-radio-group v-model="localCheckedTimes" size="small" @change="handleCheckedTimesChange">
                  <div v-for="time in this.$store.state.times" class="radio-button" :key="time.value">
                    <el-radio-button 
                      :label="time.title" 
                      style="margin-top: 5px"
                      class="check-item">
                    </el-radio-button>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="程度" class="check-group"> 
                <br>    
                <el-checkbox-group v-model="localCheckedLevels" @change="handleCheckedLevelsChange">
                  <el-checkbox label="Level 1" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="Level 2" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="Level 3" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="Level 4" class="check-item"></el-checkbox>
                  <br>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="檔案類型" class="check-group"> 
                <br>    
                <el-checkbox-group v-model="localCheckedTypes" @change="handleCheckedTypesChange">
                  <el-checkbox label="影片" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="文件" class="check-item"></el-checkbox>
                  <br>
                </el-checkbox-group>
              </el-form-item>
              <!--
              <el-form-item label="上架時間" class="check-group"> 
                <br>    
                <el-checkbox-group v-model="localCheckedTimes" @change="handleCheckedTimesChange">
                  <el-checkbox label="今日" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="最近 7 天" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="最近 30 天" class="check-item"></el-checkbox>
                  <br>
                  <el-checkbox label="最近一年" class="check-item"></el-checkbox>
                  <br>
                </el-checkbox-group>
              </el-form-item>
              -->
              <!-- <el-form-item label="機密文件" class="check-group"> 
                <br>    
                <el-checkbox-group  v-model="localCheckedSecrets" @change="handleCheckedSecretsChange">
                  <el-checkbox label="是" class="check-item"></el-checkbox>
                  <br>
                </el-checkbox-group>
              </el-form-item> -->
            </el-form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import API from '../../api/api';
export default {
  props: {
      
  },
  data: function() {
    return {
      form: {
      },
      localCheckedDeps: [],
      localCheckedLevels: [],
      localCheckedTypes: [],
      localCheckedTimes: null,
      localCheckedSecrets: [],
      tempCheckedDeps: [],
      tempCheckedLevels: [],
      tempCheckedTypes: [],
      tempCheckedTimes: null,
      tempCheckedSecrets: [],
      timer: null,
    }
  },
  created() {

    //reset
    this.$store.state.checkedDeps = null;
    this.$store.state.checkedLevels = [];
    this.$store.state.checkedTypes = [];
    this.$store.state.checkedTimes = null; 
    this.$store.state.checkedSecrets = [];

    API.getActualDeps().then((response) => {
      if(response.status) {
        redirectLogin(response.data);
        if(!JSON.parse(response.request.response).error_msg) {
          this.showHint('取得真實部門資料錯誤!');
        } else {
          this.showHint(JSON.parse(response.request.response).error_msg);	
        }
      } else {
        this.$store.state.actualDeps = response.result;
     
        if(this.$store.state.resourceList.level < 5 && this.$store.state.resourceList.level > 0) {
          this.$store.state.checkedLevels.push('Level ' + this.$store.state.resourceList.level);
        } else if(this.$store.state.resourceList.level === 5) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 2');
        } else if(this.$store.state.resourceList.level === 6) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 3');
        } else if(this.$store.state.resourceList.level === 7) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 4');
        } else if(this.$store.state.resourceList.level === 8) {
          this.$store.state.checkedLevels.push('Level 2');
          this.$store.state.checkedLevels.push('Level 3');
        } else if(this.$store.state.resourceList.level === 9) {
          this.$store.state.checkedLevels.push('Level 2');
          this.$store.state.checkedLevels.push('Level 4');
        } else if(this.$store.state.resourceList.level === 10) {
          this.$store.state.checkedLevels.push('Level 3');
          this.$store.state.checkedLevels.push('Level 4');
        } else if(this.$store.state.resourceList.level === 11) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 2');
          this.$store.state.checkedLevels.push('Level 3');
        } else if(this.$store.state.resourceList.level === 12) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 2');
          this.$store.state.checkedLevels.push('Level 4');
        } else if(this.$store.state.resourceList.level === 13) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 3');
          this.$store.state.checkedLevels.push('Level 4');
        } else if(this.$store.state.resourceList.level === 14) {
          this.$store.state.checkedLevels.push('Level 2');
          this.$store.state.checkedLevels.push('Level 3');
          this.$store.state.checkedLevels.push('Level 4');
        } else if(this.$store.state.resourceList.level === 15) {
          this.$store.state.checkedLevels.push('Level 1');
          this.$store.state.checkedLevels.push('Level 2');
          this.$store.state.checkedLevels.push('Level 3');
          this.$store.state.checkedLevels.push('Level 4');
        }

        if(this.$store.state.resourceList.type === 'video') {
          this.$store.state.checkedTypes.push('影片');
        } else if(this.$store.state.resourceList.type === 'doc') {
          this.$store.state.checkedTypes.push('文件');  
        } else if(this.$store.state.resourceList.type === 'all') {
          this.$store.state.checkedTypes.push('影片');
          this.$store.state.checkedTypes.push('文件');  
        }

        if(this.$store.state.resourceList.startTime) {
          let day = new Date().getDate(); 
          let month = new Date().getMonth() + 1; 
          let year  = new Date().getFullYear(); 
          let nowDate = month.toString() + "/" + day.toString() + "/" + year.toString();
          if(parseInt((new Date(nowDate).getTime() / 1000)) - this.$store.state.resourceList.startTime === 0) {
            this.$store.state.checkedTimes = '今日'; 
          } else if((parseInt((new Date(nowDate).getTime() / 1000)) - this.$store.state.resourceList.startTime)/86400 === 6) {
            this.$store.state.checkedTimes = '最近 7 天'; 
          } else if((parseInt((new Date(nowDate).getTime() / 1000)) - this.$store.state.resourceList.startTime)/86400 === 29) {
            this.$store.state.checkedTimes = '最近 30 天'; 
          } else {
            this.$store.state.checkedTimes = '最近一年';
          }
        }

        if(this.$store.state.resourceList.secret === 1) {
          this.$store.state.checkedSecrets.push('是');
        }

        if(this.$store.state.resourceList.actual_depid) {
          for(let i = 0 ; i < this.$store.state.actualDeps.length ; i++) {
            if(this.$store.state.resourceList.actual_depid === this.$store.state.actualDeps[i].id) {
              this.$store.state.checkedDeps = this.$store.state.actualDeps[i].name;
              break;
            }
          }
        }

        this.showFilterRow();
        
        this.updateFilter();
      }
    });
  },
  methods: {
    /**
      * applyFilter 套用所選取的filter
      * @return none
      */
    applyFilter: function() { 
      this.$store.state.checkedLevels = this.tempCheckedLevels; 
      this.$store.state.checkedTypes = this.tempCheckedTypes;    
      this.$store.state.checkedTimes = this.tempCheckedTimes;  
      this.$store.state.checkedSecrets = this.tempCheckedSecrets;
      if (this.tempCheckedDeps.length > 1) {
        for(let i = 0 ; i < this.$store.state.actualDeps.length ; i++) {
          if(this.tempCheckedDeps[1] === this.$store.state.actualDeps[i].id) {
            this.$store.state.checkedDeps = this.$store.state.actualDeps[i].name;
            break;
          }
        }
      }

      //checkChooseFilters 檢查所選取的filter
      this.checkChooseFilters();

      //顯示所選取的filter
      this.$store.state.checkedFilterLists = 
      this.$store.state.checkedLevels.concat(
        this.$store.state.checkedTypes.concat(
          this.$store.state.checkedSecrets
        )
      );

      if(this.$store.state.checkedTimes) {
        this.$store.state.checkedFilterLists.push(this.$store.state.checkedTimes);
      }

      if(this.$store.state.checkedDeps) {
        this.$store.state.checkedFilterLists.push(this.$store.state.checkedDeps);
      }
      
      this.$store.state.isShowCheckFilter = false;

      this.$store.state.resourceList.currentPage = 1;
      this.$store.state.resourceList.offset = 0;

      this.$emit('setURL');
    },
    /**
      * cancelFilter 取消這次選取的filter
      * @return none
      */
    cancelFilter: function() {
      this.tempCheckedDeps = null;
      this.tempCheckedLevels = [];
      this.tempCheckedTypes = [];
      this.tempCheckedTimes = null;
      this.tempCheckedSecrets = [];
      this.$store.state.isShowCheckFilter = false;
    },
    /**
      * clearAllFilters 清除全部所選取的filters
      * @return none
      */
    clearAllFilters: function() {
      //clear all
      this.$store.state.checkedFilterLists = [];

      //clear individual
      this.$store.state.checkedDeps = null;
      this.$store.state.checkedLevels = [];
      this.$store.state.checkedTypes = [];
      this.$store.state.checkedTimes = null;
      this.$store.state.checkedSecrets = [];

      this.updateFilter();
      this.$store.state.isShowCheckFilter = false;

      this.$store.state.resourceList.currentPage = 1;
      this.$store.state.resourceList.offset = 0;
      this.$emit('setURL');
    },
    /**
      * updateFilter 更新所選取的filter
      * @return none
      */
    updateFilter: function() {
      this.localCheckedLevels = this.$store.state.checkedLevels;  
      this.localCheckedTypes = this.$store.state.checkedTypes;    
      this.localCheckedTimes = this.$store.state.checkedTimes;  
      this.localCheckedSecrets = this.$store.state.checkedSecrets; 
      this.tempCheckedLevels = this.$store.state.checkedLevels; 
      this.tempCheckedTypes = this.$store.state.checkedTypes;    
      this.tempCheckedTimes = this.$store.state.checkedTimes;  
      this.tempCheckedSecrets = this.$store.state.checkedSecrets;
      if (this.$store.state.checkedDeps) {
        for(let i = 0 ; i < this.$store.state.actualDeps.length ; i++) {
          if(this.$store.state.checkedDeps === this.$store.state.actualDeps[i].name) {
            this.localCheckedDeps = [this.$store.state.actualDeps[i].depid, this.$store.state.actualDeps[i].id];
            this.tempCheckedDeps = [this.$store.state.actualDeps[i].depid, this.$store.state.actualDeps[i].id];
            break;
          }
        }
      } else {
        this.localCheckedDeps = [];
        this.tempCheckedDeps = [];
      }
      this.checkChooseFilters(); 
    },
    showFilterRow: function() {
			if(this.$store.state.checkedDeps || this.$store.state.checkedLevels.length > 0 || this.$store.state.checkedTypes.length > 0 || 
       	this.$store.state.checkedTimes || this.$store.state.checkedSecrets.length > 0) {
       
      	this.$store.state.checkedFilterLists = 
				this.$store.state.checkedLevels.concat(
					this.$store.state.checkedTypes.concat(
						this.$store.state.checkedSecrets
					)
        );
        
        if(this.$store.state.checkedTimes) {
         this.$store.state.checkedFilterLists.push(this.$store.state.checkedTimes);
      	}

				if(this.$store.state.checkedDeps) {
        	this.$store.state.checkedFilterLists.push(this.$store.state.checkedDeps);
      	}
			
				this.$store.state.isShowCheckFilter = false;    
			}
    },
    /**
      * handleCheckedDepsChange 資源Deps選取
      * @param  {array}   value    - 選中的值
      * @return none
      */
    handleCheckedDepsChange(value) {
      this.localCheckedDeps = value;
      this.tempCheckedDeps = value;
    },
    /**
      * handleCheckedLevelsChange 資源Levels選取
      * @param  {array}   value    - 選中的值
      * @return none
      */
    handleCheckedLevelsChange(value) {
      this.localCheckedLevels = value;
      this.tempCheckedLevels = value;
    },
    /**
      * handleCheckedTypesChange 資源Types選取
      * @param  {array}   value    - 選中的值
      * @return none
      */
    handleCheckedTypesChange(value) {
      this.localCheckedTypes = value;
      this.tempCheckedTypes = value;
    },
    /**
      * handleCheckedTimesChange 資源Ctimes選取
      * @param  {array}   value    - 選中的值
      * @return none
      */
    handleCheckedTimesChange(value) {
      this.localCheckedTimes = value;
      this.tempCheckedTimes = value;
    },
    /**
      * handleCheckedSecretsChange 資源Secrets選取
      * @param  {array}   value    - 選中的值
      * @return none
      */
    handleCheckedSecretsChange(value) {
      this.localCheckedSecrets = value;
      this.tempCheckedSecrets = value;
    },
    /**
      * checkChooseFilters 檢查所選取的filter
      * @return none
      */
    checkChooseFilters() { 
      if(this.$store.state.checkedDeps) {
        for(let i = 0 ; i < this.$store.state.actualDeps.length ; i++) {
          if(this.$store.state.checkedDeps === this.$store.state.actualDeps[i].name) {
            this.$store.state.resourceList.actual_depid = this.$store.state.actualDeps[i].id;
            break;
          }
        }
      } else {
        this.$store.state.resourceList.actual_depid = null;
      }

      //Level
      if(this.$store.state.checkedLevels.length === 1) {
        this.$store.state.resourceList.level = Number(this.$store.state.checkedLevels[0].split(' ')[1]);
      } else if(this.$store.state.checkedLevels.length === 2) {
        if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) === 2) {
          this.$store.state.resourceList.level = 5;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) === 3) {
          this.$store.state.resourceList.level = 6;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) === 4) {
          this.$store.state.resourceList.level = 7;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) === 6) {
          this.$store.state.resourceList.level = 8;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) === 8) {
          this.$store.state.resourceList.level = 9;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) === 12) {
          this.$store.state.resourceList.level = 10;  
        }
      } else if(this.$store.state.checkedLevels.length === 3) {
        if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) * Number(this.$store.state.checkedLevels[2].split(' ')[1]) === 6) {
          this.$store.state.resourceList.level = 11;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) * Number(this.$store.state.checkedLevels[2].split(' ')[1]) === 8) {
          this.$store.state.resourceList.level = 12;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) * Number(this.$store.state.checkedLevels[2].split(' ')[1]) === 12) {
          this.$store.state.resourceList.level = 13;  
        } else if(Number(this.$store.state.checkedLevels[0].split(' ')[1]) * Number(this.$store.state.checkedLevels[1].split(' ')[1]) * Number(this.$store.state.checkedLevels[2].split(' ')[1]) === 24) {
          this.$store.state.resourceList.level = 14;  
        } 
      } else if(this.$store.state.checkedLevels.length === 4) {
        this.$store.state.resourceList.level = 15;
      } else {
        this.$store.state.resourceList.level = null;
      }

      //Types
      if(this.$store.state.checkedTypes.length === 2) {
        this.$store.state.resourceList.type = 'all';
      } else if(this.$store.state.checkedTypes.length === 1) { 
        if(this.$store.state.checkedTypes[0] === '影片') {
          this.$store.state.resourceList.type = 'video'; 
        } else {
          this.$store.state.resourceList.type = 'doc'; 
        }
      } else {
        this.$store.state.resourceList.type = null; 
      }

      //Time
      let index = 0;
      let day = new Date().getDate(); 
      let month = new Date().getMonth() + 1; 
      let year  = new Date().getFullYear(); 
      let nowDate = month.toString() + "/" + day.toString() + "/" + year.toString();

      if(this.$store.state.checkedTimes) {
        /*
        for(let i = 0 ; i < this.$store.state.checkedTimes.length ; i++) {
          if(this.$store.state.checkedTimes[i] === '今日' && index < 1) {
            index = 1;
          } else if(this.$store.state.checkedTimes[i] === '最近 7 天' && index < 2) {
            index = 2;
          } else if(this.$store.state.checkedTimes[i] === '最近 30 天' && index < 3) {
            index = 3;
          } else if(this.$store.state.checkedTimes[i] === '最近一年' && index < 4) {
            index = 4;
          }
        }
        */
        if(this.$store.state.checkedTimes === '今日') {
          index = 1;
        } else if(this.$store.state.checkedTimes === '最近 7 天') {
          index = 2;
        } else if(this.$store.state.checkedTimes === '最近 30 天' ) {
          index = 3;
        } else if(this.$store.state.checkedTimes === '最近一年') {
          index = 4;
        }

        if(index === 1) {
          this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)); 
          this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400; 
        } else if(index === 2) {
          this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)) - 86400 * 6; 
          this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400; 
        } else if(index === 3) {
          this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)) - 86400 * 29; 
          this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400; 
        } else {
          this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)) - 86400 * 364;  
          this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400;  
        }
      } else {
        this.$store.state.resourceList.startTime = null; 
        this.$store.state.resourceList.endTime = null; 
      }

      //Secret
      if(this.$store.state.checkedSecrets.length > 0) {
        this.$store.state.resourceList.secret = 1; 
      } else {
        this.$store.state.resourceList.secret = null; 
      }

    },
    /*
    /**
      * closeHint close hint 視窗
      * @return none
      */
    closeHint: function() {
      this.hint.display = false;
      this.$store.state.hintStatus.edit = false;
      clearTimeout(this.timer);
    },
    /**
      * showHint 
      * @param  {string} message - message
      * @return none
      */
    showHint: function(message) {
      if(this.timer) {
        clearTimeout(this.timer);	
      }
      this.hint.display = true;
      this.hint.message = message;	
      this.$store.state.showHint = true;
      this.$store.state.hintStatus.edit = true;
      this.timer = setTimeout(()=>{
        if(this.$store.state.showHint) {
          this.$store.state.showHint = false;
          this.$store.state.hintStatus.edit = false;
        }
      }, this.$store.state.fadeOutTime);
    },    
  }
}
</script>

<style scoped lang="scss">
$white: #ffffff;
$blue-color: #2E90F4;
$black-color: #222222;
$gray-color: #626874;

.apply-btn {
  float: left;
  display: block;
  background-color: $blue-color;
  color: $white;
  width: 76px;
  margin-top: 16px;
  margin-left: 20px;
}

.apply-btn:hover {
  background: #42A0FF;
}

.cancel-btn {
  background-color: $white;
  color: $blue-color; 
  display: block;
  width: 76px;
  margin-top: 16px;
  margin-left: 106px;
}

.cancel-middle-btn {
  float: left;
  background-color: $white;
  color: $blue-color; 
  display: block;
  width: 76px;
  margin-top: 16px;
  margin-left: 10px;
}

.clear-btn {
  background-color: $white;
  color: $blue-color; 
  display: block;
  width: 96px;
  margin-top: 16px;
  margin-left: 192px;
}

.check-group {
  float: left;
  display: block;
  margin-left: 20px;
  width: 100px;
  font-size: 16px;
  font-weight: 700;
  color: $black-color;
}

.check-item {
  float: left;
  display: block;
  color: $gray-color;
  font-weight: 500;
}

.radio-button {
  margin-top: 5px;
  border-radius: 3px;  
}

.modal-container {
  position: fixed;
  /*width: 97%;*/
  z-index: 1000;
  margin-top: -32px;
  height: auto;
  overflow: hidden;
  border-radius: 3px;
  background-color: $white;
  border: 1px solid #EEE;
  box-shadow: 0 2px 4px 1px rgba(0,0,0,0.10);
}

.modal-body {
  display: block;
  text-align: left;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// CheckFilter.vue?2d940d56